import { render } from "./SidebarAdmin.vue?vue&type=template&id=746ba95a&ts=true"
import script from "./SidebarAdmin.vue?vue&type=script&lang=ts"
export * from "./SidebarAdmin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__